<template>
    <div class="c-branch-reservation">
        <form
            class="c-branch-reservation__form"
            v-if="!isSuccess"
            @submit.prevent
            ref="formEl"
            @keydown.enter="onEnter"
        >
            <div class="c-branch-reservation__main">
                <ReservationMain />
            </div>

            <div class="c-branch-reservation__footer">
                <div
                    class="sc-text"
                    v-html="selectedBranch ? replaceTranslate(
                        $t('BranchReservation.Footer.infoText'),
                        '<strong>',
                        selectedBranch.custom_reservation_cutoff,
                        '</strong>'
                    ) : ''"
                ></div>

                <div class="sc-button">
                    <button
                        :disabled="isSubmitDisabled"
                        class="c-btn c-btn--cart"
                        :class="{
                            'is-loading': isUpdating || isInitializing
                        }"
                        type="submit"
                        v-html="replaceTranslate(
                            $t('BranchReservation.Footer.submit'),
                            totals ? formatPrice(totals.price_vat) : '-',
                        )"
                        ref="submitButton"
                    ></button>
                </div>
            </div>
        </form>

        <div
            v-else
            class="c-branch-reservation__success"
        >
            <ReservationSuccess />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { replaceTranslate } from "Functions/replaceTranslate"
import { formatPrice } from "FrontendJsAssets/common/format";
import ReservationMain from 'VueComponents/BranchReservation/ReservationMain';
import ReservationSuccess from 'VueComponents/BranchReservation/ReservationSuccess';
import { tippyAlert } from 'Functions/tippy';

export default {
    data() {
        return {
            isSuccess: false
        }
    },
    components: {
        ReservationMain: ReservationMain,
        ReservationSuccess: ReservationSuccess
    },
    methods: {
        replaceTranslate: replaceTranslate,
        formatPrice: formatPrice,
        ...mapActions([
            'submitForm',
            'setOrderId'
        ]),
        onEnter(event) {
            if (event.target.name === 'voucher') {
                event.preventDefault()
                return false
            }
        }
    },
    computed: {
        ...mapState([
            'totals',
            'selectedQuantity',
            'isInitializing',
            'orderId'
        ]),
        ...mapGetters([
            'selectedBranch',
            'isUpdating',
            'isSubmitDisabled',
        ])
    },
    mounted() {
        this.$nextTick(() => {
            $(this.$refs.formEl).validate({
                ignore: ":hidden,[name='quantity'],[name='voucher']",
                rules: {
                    phone: {
                        phone: true
                    }
                },
                submitHandler: (form) => {
                    if (!this.selectedBranch) {
                        return false
                    }

                    const formData = {}

                    for (const [ key, value ] of (new FormData(form)).entries()) {
                        if (key === 'voucher') continue

                        formData[key] = value
                    }

                    this.submitForm(formData).then((response) => {
                        if (!response) return

                        if (response.error) {
                            tippyAlert(this.$refs.submitButton, response.message, {
                                theme: 'error'
                            })

                            return
                        }

                        this.isSuccess = true;
                        this.setOrderId(response.data.orderId)
                    })
                }
            })

            $(this.$refs.formEl).find('input[data-autocomplete-name=company]').each(function() {
                var autocompleteFieldEl = this;
                var $autocompleteField = $(autocompleteFieldEl);
                var $form = $autocompleteField.closest("form");
                var $orgNumField = $form.find('input[data-autocomplete-name=org_num]');
                var orgNumFieldEl = $orgNumField[0];

                if (!$autocompleteField.hasClass("has-finstat-initialized")) {
                    $autocompleteField.autocomplete({
                        source: function(request, response) {
                            rEvent.dispatch("Finstat.source.before", autocompleteFieldEl);

                            $autocompleteField.addClass("is-loading");

                            if (autocompleteFieldEl.sourceRequest) {
                                autocompleteFieldEl.sourceRequest.abort();
                            }

                            autocompleteFieldEl.sourceRequest = $.ajax({
                                url: '/finstat/autocomplete',
                                dataType: "json",
                                data: {
                                    limit: 10,
                                    query: request.term
                                },
                                timeout: 6000,
                                success: function (data) {
                                    $autocompleteField.removeClass("is-loading");

                                    var mapData = [];
                                    if (data.result.Results && data.result.Results.Company) {
                                        mapData = data.result.Results.Company;

                                        if (typeof data.result.Results.Company[0] == "undefined") {
                                            mapData = [
                                                data.result.Results.Company
                                            ];
                                        }
                                    }

                                    response($.map(mapData, function(item) {
                                        item.label = item.Name + " - " + item.Ico;
                                        item.value = item.Name;

                                        return item;
                                    }));

                                    rEvent.dispatch("Finstat.source.after", autocompleteFieldEl, data);
                                },
                                error: function(jqXHR, textStatus, errorThrown) {
                                    if (textStatus !== "abort" && errorThrown !== "abort") {
                                        $autocompleteField.removeClass("is-loading");
                                    }

                                    rEvent.dispatch("Finstat.source.error", autocompleteFieldEl, jqXHR, textStatus, errorThrown);
                                }
                            });
                        },
                        html: true,
                        minLength: 3,
                        open: function(event, ui) {
                            var width = $autocompleteField.outerWidth();
                            $("ul.ui-autocomplete").width(width);
                        },
                        select: function(event, ui) {
                            rEvent.dispatch("Finstat.select.before", autocompleteFieldEl);

                            $autocompleteField.addClass("is-loading");

                            if (autocompleteFieldEl.selectRequest) {
                                autocompleteFieldEl.selectRequest.abort();
                            }

                            autocompleteFieldEl.selectRequest = $.ajax({
                                url: '/finstat/fetch-data/' + ui.item.Ico,
                                dataType: "json",
                                timeout: 6000,
                                success: function (data) {
                                    $autocompleteField.removeClass("is-loading");

                                    if (data.error) {
                                        Eshop.alert(data.error, {type: "error", 'z_index': 11000});
                                    } else {
                                        $form.find('input[data-autocomplete-name=org_num]').val(data.result.Ico ? data.result.Ico : "").trigger("change", [true]);
                                        $form.find('input[data-autocomplete-name=company]').val(data.result.Name ? data.result.Name : "");
                                        $form.find('input[data-autocomplete-name=tax_num]').val(data.result.Dic ? data.result.Dic : "");
                                        $form.find('input[data-autocomplete-name=vat_num]').val(data.result.IcDPH ? data.result.IcDPH : "");
                                    }

                                    rEvent.dispatch("Finstat.select.after", autocompleteFieldEl, data);
                                },
                                error: function(jqXHR, textStatus, errorThrown) {
                                    if (textStatus !== "abort" && errorThrown !== "abort") {
                                        $autocompleteField.removeClass("is-loading");
                                    }

                                    rEvent.dispatch("Finstat.select.error", autocompleteFieldEl, jqXHR, textStatus, errorThrown);
                                }
                            });
                        }
                    });

                    $autocompleteField.addClass("has-finstat-initialized");
                }

                if ($orgNumField.length > 0 && !$orgNumField.hasClass("has-finstat-initialized")) {
                    $orgNumField.on("change", function (e, isFinstatChange) {
                        rEvent.dispatch("Finstat.orgNum.before", orgNumFieldEl);

                        var val = $(this).val();

                        if (orgNumFieldEl.changeRequest) {
                            orgNumFieldEl.changeRequest.abort();
                        }

                        if (isFinstatChange || !val || !$(this).valid()) {
                            if (isFinstatChange) {
                                $orgNumField.removeClass("is-loading");
                            }

                            return;
                        }

                        $orgNumField.addClass("is-loading");

                        orgNumFieldEl.changeRequest = $.ajax({
                            url: '/finstat/fetch-data/' + val,
                            dataType: "json",
                            timeout: 6000,
                            success: function (data) {
                                $orgNumField.removeClass("is-loading");

                                if (data.error) {
                                    Eshop.alert(data.error, {type: "error", 'z_index': 11000});
                                } else {
                                    $form.find('input[data-autocomplete-name=company]').val(data.result.Name ? data.result.Name : "");
                                    $form.find('input[data-autocomplete-name=tax_num]').val(data.result.Dic ? data.result.Dic : "");
                                    $form.find('input[data-autocomplete-name=vat_num]').val(data.result.IcDPH ? data.result.IcDPH : "");
                                }

                                rEvent.dispatch("Finstat.orgNum.after", orgNumFieldEl, data);
                            },
                            error: function() {
                                if (textStatus !== "abort" && errorThrown !== "abort") {
                                    $orgNumField.removeClass("is-loading");
                                }

                                rEvent.dispatch("Finstat.orgNum.error", orgNumFieldEl, jqXHR, textStatus, errorThrown);
                            }
                        });
                    });
                    $orgNumField.addClass("has-finstat-initialized");
                }
            });
        })
    }
}
</script>